export default __webpack_public_path__ + "static/media/BeIcon3.147228f3.svg";